export default __webpack_public_path__ + "static/media/2_2.b6534232.jpg";